const HIDDEN_SESSION_CLOSE_TRIGGER_COUNT = 4;
const HIDDEN_SESSION_CLOSE_WINDOW_MS = 1500;

export interface HiddenSessionCloseTracker {
  recordTrigger: (now: number) => boolean;
}

export const createHiddenSessionCloseTracker = (): HiddenSessionCloseTracker => {
  let firstTriggerAt = 0;
  let triggerCount = 0;

  return {
    recordTrigger: (now: number) => {
      if (!firstTriggerAt || now - firstTriggerAt > HIDDEN_SESSION_CLOSE_WINDOW_MS) {
        firstTriggerAt = now;
        triggerCount = 1;

        return false;
      }

      triggerCount += 1;

      if (triggerCount >= HIDDEN_SESSION_CLOSE_TRIGGER_COUNT) {
        firstTriggerAt = 0;
        triggerCount = 0;

        return true;
      }

      return false;
    }
  };
};
